import { useMutation, useQueryClient } from '@tanstack/react-query'
import { requestMagicLink, verifyMagicLink } from '../services/magicLink'
import { setAuthToken } from '../utils/authToken'

export function useRequestMagicLink() {
  return useMutation({
    mutationFn: (email: string) => requestMagicLink(email),
  })
}

export function useVerifyMagicLink() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (token: string) => verifyMagicLink(token),
    onSuccess: (data) => {
      setAuthToken(data.token)
      queryClient.setQueryData(['currentUser'], data.user)
    },
  })
}
